var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMother(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 44.5,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 44.5,
    width: 4,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 48.5,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 40.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 44.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.709,30.5h16.582c0.391,0,0.709-0.318,0.709-0.709V13.209c0-0.391-0.318-0.709-0.709-0.709H34.709 C34.318,12.5,34,12.818,34,13.209v16.582C34,30.182,34.318,30.5,34.709,30.5z M35,23.5h2v-1h-2v-2h2v-1h-2v-2h2v-2h2v-2h2v2h1v-2h2 v2h1v-2h2v2h2v2h2v2h-2v1h2v2h-2v1h2v2h-2v2h-2v2h-2v-2h-1v2h-2v-2h-1v2h-2v-2h-2v-2h-2V23.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 31.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 36.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,6.5v-1c0-0.553-0.447-1-1-1s-1,0.447-1,1v1h-1v-3h-4h-2h-2h-2h-2h-2h-2h-2h-4v3h-1v-1c0-0.553-0.448-1-1-1 s-1,0.447-1,1v1h-1v-1c0-0.553-0.448-1-1-1s-1,0.447-1,1v1h-4h-6h-2H8H0v5h4c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v1h4 c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v1h4c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v20h4c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v1h4 c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v1h4c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v1h4c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v1h4 c0.552,0,1,0.447,1,1s-0.448,1-1,1H0v3h60v-50H57z M4,34.5c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S4.552,34.5,4,34.5z  M4,31.5c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S4.552,31.5,4,31.5z M4,28.5c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1 S4.552,28.5,4,28.5z M16,38.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S15.448,38.5,16,38.5z M8,8.5h6v17h-2v1 c0,0.553-0.448,1-1,1s-1-0.447-1-1v-1H8V8.5z M7,29.5h7v7H7V29.5z M14,39.5c0,0.552-0.448,1-1,1s-1-0.448-1-1s0.448-1,1-1 S14,38.948,14,39.5z M21,47.5c0.552,0,1,0.447,1,1s-0.448,1-1,1h-1v2h-8v-2h-1c-0.552,0-1-0.447-1-1s0.448-1,1-1h1v-1h-1 c-0.552,0-1-0.447-1-1s0.448-1,1-1h1v-2h8v2h1c0.552,0,1,0.447,1,1s-0.448,1-1,1h-1v1H21z M18,39.5c0-0.552,0.448-1,1-1 s1,0.448,1,1s-0.448,1-1,1S18,40.052,18,39.5z M22,31.5h-2v1c0,0.553-0.448,1-1,1s-1-0.447-1-1v-1h-2v-23h6V31.5z M50,5.5h2v1h-2 V5.5z M46,5.5h2v1h-2V5.5z M42,5.5h2v1h-2V5.5z M38,5.5h2v1h-2V5.5z M34,5.5h2v1h-2V5.5z M32,13.209 c0-1.494,1.215-2.709,2.709-2.709h16.582c1.494,0,2.709,1.215,2.709,2.709v16.582c0,1.494-1.215,2.709-2.709,2.709H34.709 C33.215,32.5,32,31.285,32,29.791V13.209z M28,15.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S27.448,15.5,28,15.5z M28,18.5 c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S27.448,18.5,28,18.5z M28,21.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1 S27.448,21.5,28,21.5z M28,24.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S27.448,24.5,28,24.5z M28,27.5c0.552,0,1,0.448,1,1 s-0.448,1-1,1s-1-0.448-1-1S27.448,27.5,28,27.5z M28,30.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S27.448,30.5,28,30.5z  M25,17.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S24.448,17.5,25,17.5z M25,21.5c0.552,0,1,0.448,1,1s-0.448,1-1,1 s-1-0.448-1-1S24.448,21.5,25,21.5z M55,40.5c0.553,0,1,0.447,1,1s-0.447,1-1,1h-1v2h1c0.553,0,1,0.447,1,1s-0.447,1-1,1h-1v2h1 c0.553,0,1,0.447,1,1s-0.447,1-1,1h-1v2H26v-2h-1c-0.552,0-1-0.447-1-1s0.448-1,1-1h1v-2h-1c-0.552,0-1-0.447-1-1s0.448-1,1-1h1v-2 h-1c-0.552,0-1-0.447-1-1s0.448-1,1-1h1v-2h-1c-0.552,0-1-0.447-1-1s0.448-1,1-1h1v-2h28v2h1c0.553,0,1,0.447,1,1s-0.447,1-1,1h-1 v2H55z M56,26.5c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S56.552,26.5,56,26.5z M56,19.5c-0.552,0-1-0.448-1-1s0.448-1,1-1 s1,0.448,1,1S56.552,19.5,56,19.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10.5,
    width: 2,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10.5,
    width: 2,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 48.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 40.5,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 48.5,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 36.5,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 17.5,
    width: 8,
    height: 8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMother);
export default __webpack_public_path__ + "static/media/mother.56237b033df76fbc65754f93ea265ef8.svg";
export { ForwardRef as ReactComponent };